import baseapi from "../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";

export const getCampaignsAPI = async (setCampaigns) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/sales/campaigns");

        console.log("Data got successfully", response.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setCampaigns(response.data.datalist);
        //setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}
export const getCallerByCampaignAPI = async (campaignid, setCallers) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/sales/filter/callers/" +campaignid);

        console.log("Data got successfully", response.data.datalist);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setCallers(response.data.datalist);
        //setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}
export const getStagesAPI = async (setStages) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/sales/stages");

        console.log("Data got successfully", response.data.datalist);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setStages(response.data.datalist);
        //setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}
export const getDispositionAPI = async (stageid, setDispositions) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/sales/disposition/" +stageid);

        console.log("Data got successfully", response.data.datalist);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setDispositions(response.data.datalist);
        //setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}
export const getSubdispositionAPI = async (dispositionid, setSubDispositions) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/sales/sub-disposition/" +dispositionid);

        console.log("Data got successfully", response.data.datalist);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setSubDispositions(response.data.datalist);
        //setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}
export const getCallersAPI = async (setCallers) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/sales/allcallers");

        console.log("Data got successfully", response.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setCallers(response.data.data);
        //setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}

export const LeadsAPI = async (setLeads, setLeadCount, setPayAmount, currentPage, perpagedata, setPageCount, setDataLoader, filterparams) =>{

    setDataLoader(true);

    let searchparam = "";

    if(filterparams !== "" && filterparams !== null && filterparams !== undefined)
    {
        searchparam = `?${filterparams.toString()}`;
    }
    else
    {
        searchparam = "?page=" + currentPage + "&per_page=" + perpagedata;
    }

    try 
    {
        const response = await baseapi.get("/api/sales/report/leads" + searchparam);

        console.log("Data got successfully", response.data.leadlist.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setLeads(response.data.leadlist.data);
        setLeadCount(response.data.totalcount);
        setPayAmount(response.data.totalpay);
        //setLoading(false);
        setDataLoader(false);

        if(response.data.leadlist.data.length > 0)
        {
            console.log('Total count====='+response.data.totalcount);
            let pagecount = Math.ceil(response.data.totalcount / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }
    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }
}

export const CallerSummaryAPI = async (setCallerSummary) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/sales/report/callerwise-summary");

        console.log("Data got successfully", response.data.summary);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setCallerSummary(response.data.summary);
        //setLoading(false);
    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}

export const LeadStatusAPI = async (setLeadStatus, setLeadStatusOptions,setLeadStatusSeries, setShowLeadStatusChart, setShowLeadFunnelReport, selectcaller) =>
{
    //setLoading(true);
    //setShowLeadStatusChart(true);

    try 
    {
        let response;

        if(selectcaller !== "" && selectcaller !== null && selectcaller !== undefined)
        {
            response = await baseapi.get("/api/sales/report/lead-status/" + selectcaller);
        }
        else
        {
            response = await baseapi.get("/api/sales/report/lead-status");
        }

        console.log("Pie Data got successfully", response.data.series);
        setLeadStatusOptions(response.data.options);
        setLeadStatusSeries(response.data.series);
        setShowLeadStatusChart(false);
        setShowLeadFunnelReport(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}

export const CallerStatisticsAPI = async (setCallerStats, setShowCallerStats, selectcaller) =>
{
    //setLoading(true);
    //setShowLeadStatusChart(true);

    //console.log('caller====' + selectcaller);

    try 
    {
        const response = await baseapi.get("/api/sales/report/caller/" + selectcaller + "/leads");

        console.log("Caller Data got successfully", response.data.stats);
        //const statsdata = response.data.stats;

        //console.log('total count====' + statsdata.totalcount);
        setCallerStats(response.data.stats);
        setShowCallerStats(true);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}

export const getFilterDataAPI = async (setCallers, setStages, setPrograms, setInstitutes, setSources, setTeams) =>
{
    try
    {
        const response = await baseapi.get("/api/sales/filter-data");

        console.log("Data got successfully", response.data.datalist);
        //let userdata = ['ram', 'shyam', 'rohit'];
        //setStages(response.data.datalist);
        //setLoading(false);

        //setCampaigns(response.data.datalist.campaigns);
        setCallers(response.data.datalist.users);
        setStages(response.data.datalist.stages);
        setPrograms(response.data.datalist.programs);
        setInstitutes(response.data.datalist.institutes);
        setSources(response.data.datalist.sources);
        setTeams(response.data.datalist.teams);

    }
    catch (error)
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }
}

export const getExportLeadCSVAPI = async (exportparams = null, setExportBtnLoader) =>
{
    setExportBtnLoader(true);

    let searchparam = "";

    if(exportparams !== "" && exportparams !== null && exportparams !== undefined)
    {
        searchparam = `?${exportparams.toString()}`;
    }

    try
    {
        const response = await baseapi.get("/api/sales/report/export-leads-csv" + searchparam, { responseType: 'blob' });

        const blob = new Blob([response.data], { type: 'text/csv' });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Lead_Report_Export.csv');

        document.body.appendChild(link);
        link.click();

        link.remove();

        window.URL.revokeObjectURL(url);

        console.log("Data got successfully", response.data.leadlist.data);

        setExportBtnLoader(false);
    }
    catch (error)
    {
        console.error("Error in user list:", error);
        //setLoading(false);
        setExportBtnLoader(false);
    }
}

export const CallerAPI = async (teamid, setCallers) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/sales/setting/callers/" + teamid);

        console.log("Data got successfully", response.data.datalist);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setCallers(response.data.datalist.callerlist);
        //setLoading(false);
        //setMultiCallers(response.data.datalist.callerlist);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}

